import { type OrganizationDto } from '@/types/dtos/organizations/organization.dto';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ActiveOrganizationState {
  activeOrganization?: OrganizationDto;
  setActiveOrganization: (change: OrganizationDto | undefined) => void;
}

export const useActiveOrganizationStore = create<ActiveOrganizationState>()(
  persist(
    (set) => ({
      activeOrganization: undefined,
      setActiveOrganization: (change) => set(() => ({ activeOrganization: change })),
    }),
    {
      name: 'active-organization',
    },
  ),
);
